import { createAction, handleActions } from "redux-actions";
import createPromiseThunk from "lib/createPromiseThunk";
import * as api from "lib/api/recruitList";

// 모집정보 list
const RECRUIT_LIST = "recruit/RECRUIT_LIST";
const RECRUIT_LIST_PENDING = "recruit/RECRUIT_LIST_PENDING";
const RECRUIT_LIST_SUCCESS = "recruit/RECRUIT_LIST_SUCCESS";

// 현재 페이지 정보
const CURRENT_PAGE = "recruit/CURRENT_PAGE";

// 검색 데이터 저장
const SEARCH_DATA = "recruit/SEARCH_DATA";

// 내가 참여가능한 연구만 보기
const RECRUIT_MYLIST = "recruit/RECRUIT_MYLIST";
const RECRUIT_MYLIST_PENDING = "recruit/RECRUIT_MYLIST_PENDING";
const RECRUIT_MYLIST_SUCCESS = "recruit/RECRUIT_MYLIST_SUCCESS";

// 검색값 셋팅
const CHANGE_SEARCH_DEFAULT = "recruit/CHANGE_SEARCH_DEFAULT";

export const recruitmentList = createPromiseThunk(
  RECRUIT_LIST,
  api.recruitList
);
export const recruitMyList = createPromiseThunk(
  RECRUIT_MYLIST,
  api.recruitMyList
);
export const currentPage = createAction(CURRENT_PAGE);
export const searchData = createAction(SEARCH_DATA);
export const changeSchDefault = createAction(CHANGE_SEARCH_DEFAULT);

const initialState = {
  data: null,
  paging: null,
  defaultMap: null,
  setting: null,
  search: { cp: 1 }
};

export default handleActions(
  {
    [RECRUIT_LIST_PENDING]: state => ({
      ...state,
      data: null,
      paging: null,
      defaultMap: null
    }),
    [RECRUIT_LIST_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: payload.data.dataList,
      paging: payload.data.paging,
      defaultMap: payload.data.defaultMap
    }),
    [RECRUIT_MYLIST_PENDING]: state => ({
      ...state,
      data: null,
      pading: null,
      defaultMap: null
    }),
    [RECRUIT_MYLIST_SUCCESS]: (state, { payload }) => ({
      ...state,
      data: payload.data.dataList,
      paging: payload.data.paging,
      defaultMap: payload.data.defaultMap
    }),
    [CURRENT_PAGE]: (state, { payload }) => ({
      ...state,
      search: { ...state.search, cp: payload }
    }),
    [SEARCH_DATA]: (state, { payload }) => ({
      ...state,
      search: payload
    }),
    [CHANGE_SEARCH_DEFAULT]: (state, { payload }) => ({
      ...state,
      setting: payload
    })
  },
  initialState
);
